module.exports = __webpack_public_path__ + "static/media/twitter.f78aabe6.svg";